module.exports = __webpack_public_path__ + "static/media/app-store-badge-ru.1e0af3f0.svg";